import type {CampoDore, OpcionesDore} from '@cnc/contracts';
import {tr, trx} from '../i18n/idioma';
import {AYUDA_DORE} from './ayuda-dore';
import {GRUPOS_DORE, type ValoresDore} from './campos-dore';
import {NotaDeAyuda} from './nota-de-ayuda';

// Los campos del formulario agrupados como la ficha, con sus notas de ayuda.
export function CamposDeDore({
  valores,
  onCambiar,
  opciones,
}: {
  valores: ValoresDore;
  onCambiar: (campo: CampoDore, valor: string) => void;
  opciones: OpcionesDore | undefined;
}) {
  return (
    <>
      <div className="grid gap-4 lg:grid-cols-3">
        {GRUPOS_DORE.map(grupo => (
          <fieldset key={trx(grupo.titulo)} className="space-y-2">
            <legend className="text-sm font-medium text-apagado">{trx(grupo.titulo)}</legend>
            {grupo.campos.map(c => (
              <label key={c.campo} className="flex items-center justify-between gap-3 text-sm">
                <span className="text-apagado">
                  {trx(c.etiqueta)}
                  {AYUDA_DORE[c.campo] && (
                    <NotaDeAyuda titulo={trx(c.etiqueta)} texto={AYUDA_DORE[c.campo]!} dentroDeEtiqueta />
                  )}
                </span>
                <input
                  aria-label={trx(c.etiqueta)}
                  type={c.tipo === 'fecha' ? 'date' : 'text'}
                  inputMode={c.tipo === 'numero' ? 'decimal' : c.tipo === 'entero' ? 'numeric' : undefined}
                  list={c.lista ? `dore-${c.lista}` : undefined}
                  value={valores[c.campo]}
                  onChange={e => onCambiar(c.campo, e.target.value)}
                  className="w-44 rounded-md border border-linea px-2 py-1 text-right tabular-nums"
                />
              </label>
            ))}
          </fieldset>
        ))}
      </div>
      <label className="mt-3 block text-sm text-apagado">
        {tr('Comentarios', 'Comments')}
        <textarea
          aria-label={tr('Comentarios', 'Comments')}
          value={valores.comentarios}
          onChange={e => onCambiar('comentarios', e.target.value)}
          rows={3}
          className="mt-1 w-full rounded-md border border-linea px-2 py-1 text-sm text-tinta"
        />
      </label>
      {(['estados', 'proveedores', 'intermediarias', 'compradores'] as const).map(lista => (
        <datalist key={lista} id={`dore-${lista}`}>
          {(opciones?.[lista] ?? []).map(v => (
            <option key={v} value={v} />
          ))}
        </datalist>
      ))}
      <p className="mt-2 text-xs text-apagado">
        {tr(
          'Deja un campo vacío para borrar el dato. Las empresas se eligen de la lista; si escribes una nueva, se crea. Sin estado, la etapa la calcula la app con los datos.',
          'Leave a field empty to clear it. Companies are picked from the list; typing a new one creates it. Without a status, the app works out the stage from the data.',
        )}
      </p>
    </>
  );
}
